import { render, staticRenderFns } from "./tabs-cmp.vue?vue&type=template&id=6dc90f90&scoped=true"
import script from "./tabs-cmp.vue?vue&type=script&lang=js"
export * from "./tabs-cmp.vue?vue&type=script&lang=js"
import style0 from "./tabs-cmp.vue?vue&type=style&index=0&id=6dc90f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc90f90",
  null
  
)

export default component.exports